// A project is named by `(owner, key)`. A bare key can name several owners'
// projects, and the server's by-key routes answer such a key 409
// `ambiguous_key` with the owner/key pairs the caller may address (server
// 736d2d755) — they never pick one. These helpers keep the owner on every
// by-key read the shell makes, and read the candidates off that 409 so a
// caller can SHOW them; nothing here picks a project for the user.
//
// Each function is self-contained (FA204 / frank trap): no module-scope helper.

// The libraries the CURRENT project links, as `owner/key` refs — the
// project's own `useLibraries` record (GET /core/projects/:id/libraries, each
// row with its owner slug). A row with no owner is left out rather than sent
// as a bare key. The insert panel's library used to be the hardcoded legacy
// key 'default.symbo.ls', and its deleted switcher row dropped the owner the
// same way (`projectPath.split('/')[1] + '.symbo.ls'`).
export async function insertPanelLibraryRefs() {
  const el = this
  const root = (el.getRootState && el.getRootState()) || (el.state && el.state.root) || {}
  const projectId = root.projectId || (root.data && (root.data._id || root.data.id)) || null
  const sdk = el.sdk
  if (!projectId || !sdk || typeof sdk.getProjectLibraries !== 'function') return []
  const rows = await sdk.getProjectLibraries(projectId)
  const list = Array.isArray(rows) ? rows : (rows && (rows.items || rows.data)) || []
  return list
    .filter((row) => row && typeof row.owner === 'string' && row.owner && row.key)
    .map((row) => ({
      ref: row.owner + '/' + row.key,
      owner: row.owner,
      key: row.key,
      name: row.name || row.key
    }))
}

// One library's project (with its merged data) by owner + key — the 2-seg
// by-key route. A ref without an owner answers null; it is never sent bare.
export async function fetchInsertPanelLibrary(ref) {
  const el = this
  const value = String(ref || '')
  const at = value.indexOf('/')
  if (at < 1 || at === value.length - 1) return null
  return el.sdk.getProjectByKey({ owner: value.slice(0, at), key: value.slice(at + 1) })
}

// The `candidates` of a 409 `ambiguous_key`, or null for any other error.
// Reads every SDK shape: a structured error (`code` / `candidates` on the
// error) and the older cause chain (BaseService wraps the HTTP error, whose
// `cause` is the response body).
export function ambiguousKeyCandidates(error) {
  let node = error
  for (let depth = 0; node && depth < 5; depth++) {
    const body = node && typeof node === 'object' ? node : null
    if (body && (body.code === 'ambiguous_key' || body.error === 'ambiguous_key')) {
      const list = Array.isArray(body.candidates) ? body.candidates : []
      return list.filter((c) => c && c.owner && c.key)
    }
    node = node && node.cause
  }
  return null
}
